/* eslint-disable jsx-a11y/alt-text */
import { Icon as MIcon } from "@mui/material";
import { IconsPack } from "./svg";
const SVGIcons = {
  delete: IconsPack.deleteIcon,
  film: IconsPack.filmIcon,
  move: IconsPack.moveIcon,
  roll: IconsPack.rollIcon,
  viewEdit: IconsPack.viewEditIcon,
  edit: IconsPack.editIcon,
  save: IconsPack.saveIcon,
  emptyBox: IconsPack.emptyBoxIcon,
};

/**
 * Componente de ícone que utiliza ícones SVG.
 *
 * @component
 * @example
 * // Exemplo de uso:
 * // <Icon name="delete" />
 *
 * @param {Object} props
 * @param {("delete" | "film" | "move" | "roll" | "viewEdit" | "edit" | "save" | "emptyBox")} props.name - Nome do ícone
 *
 * @returns {React.Component} O componente de ícone.
 */

export const Icon = ({ name, ...props }) => {
  return (
    <MIcon
      {...props}
      sx={{
        background: `url(${SVGIcons[name]})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
  );
};
